(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('ExhibitorsModalController', ExhibitorsModalController);

    ExhibitorsModalController.$inject = ['$uibModalInstance', 'users'];
    
    function ExhibitorsModalController($uibModalInstance, users) {
        var vm      = this;
        vm.users    = users
        vm.cancel   = cancel;

        activate();

        function activate() {
        }

        function cancel() {
            $uibModalInstance.close();
        }
    }

})();